import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { Workbook } from 'exceljs';
import * as fileSaver from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class ExcelService {
    private readonly exportProgressSubject = new BehaviorSubject(false);
    public exportProgress$ = this.exportProgressSubject.asObservable();

    exportToExcel(headerColumns: any[], data: any[], excelFileName: string, password: string | null = null) {
        this.exportProgressSubject.next(true);

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(excelFileName, { views: [{ state: 'frozen', ySplit: 1, activeCell: 'A1', showGridLines: true }] });

        password && worksheet.protect(password, {});

        const headerRow = worksheet.addRow(headerColumns);
        headerRow.font = { bold: true, size: 10 };
        worksheet.addRows((data || []));

        // set downloadable file name
        const timestamp = (new Date()).getTime().toString();
        const downloadableFileName = `${excelFileName}-${timestamp}.xlsx`;

        // add data and file name and download
        workbook.xlsx.writeBuffer()
            .then((buffer) => {
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                fileSaver.saveAs(blob, downloadableFileName);
                this.exportProgressSubject.next(false);
            });
    }
}